import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  HomepageInformationResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetHomepageInformations = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<HomepageInformationResponseDto>(
      {url: `/informations/homepage`, method: 'GET'
    },
      options);
    }
  

export const getApiGetHomepageInformationsQueryKey = () => {
    return ['informations','homepage'] as const;
    }

    
export const getApiGetHomepageInformationsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetHomepageInformations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetHomepageInformations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetHomepageInformationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetHomepageInformations>>> = () => apiGetHomepageInformations(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetHomepageInformations>>, TError, TData> 
}

export type ApiGetHomepageInformationsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetHomepageInformations>>>
export type ApiGetHomepageInformationsQueryError = ErrorType<unknown>



export function useApiGetHomepageInformations<TData = Awaited<ReturnType<typeof apiGetHomepageInformations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetHomepageInformations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetHomepageInformationsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



